import { combineReducers } from 'redux';

import { requirementManageReducer } from './requirementManage/requirementManageReducer';

const requirementsReducer = combineReducers({
  manage: requirementManageReducer,
});

export default requirementsReducer;
